import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook for making redirect to another page
 * @returns {*}
 */
const useRedirectToPage = () => {
  const navigate = useNavigate();

  return useCallback((endpoint, redirectWithPageReload = false) => {
    if (redirectWithPageReload) {
      window.location.replace(endpoint);
    } else {
      navigate(endpoint);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useRedirectToPage;
